import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FormStateModel } from '../../data/models/app-state';

export const selectFeatureState = createFeatureSelector<FormStateModel>('formState');

export const selectFormDirty = createSelector(
  selectFeatureState,
  (state: FormStateModel) => state
);
